import React, { useState, useEffect, useContext } from "react";
import userService from "../../services/userService";
import { toast } from "react-toastify";
import { GlobalContext } from "../../utility/GlobalContext";
import CreateAndReviewBusiness from "../Business/CreateAndReviewBusiness";
import CreateAndReviewCreator from "../Creator/CreateAndReviewCreator";

export default function CreateAndReview(props) {
  const { state, setState } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // fetch user
    fetchUser();
  }, [state.jwt]);

  const fetchUser = () => {
    setLoading(true);
    userService
      .fetchSelf(state.jwt)
      .then((response) => {
        setState({ ...state, user: response.data });
        setLoading(false);
      })
      .catch((err) => {
        // toast.error(err.response.data.msg || "Error occurred");
      });
  };

  return state.user.type === "creator" ? (
    <CreateAndReviewBusiness state={state} loading={loading} />
  ) : (
    <CreateAndReviewCreator state={state} loading={loading} />
  );
}
